import cx from 'classnames';

import { Logo as MotorwayLogo } from '@motorway/mw-highway-code';

import styles from './Logo.module.scss';

export const Logo = ({ noMargin = false }) => (
  <div className={cx(styles.logo, { [styles.noMargin]: noMargin })}>
    <MotorwayLogo size="medium" />
  </div>
);
